<template>
       <b-row>
        <b-col lg="12">
            <p>
                <strong>INSTRUCCIONES:</strong>
            </p>
            <p>{{data.instrucciones}}</p>
        </b-col>
        <b-col lg="12" v-for="(pregunta,index) in data.preguntas" :key="pregunta.id">
            <p>
                <strong :id="`txtPregunta${index}`">Pregunta No. {{index + 1}}</strong>
            </p>
            <p>{{pregunta.pregunta}}</p>
            <p>
                <span>
                <strong style="color: #aaaaaa;">Selecciona la respuesta correcta:</strong>
                </span>
                <br>
                <b-form-radio
                v-for="opcion in pregunta.opciones"
                :name="`opciones-respuestas-match${pregunta.id}`"
                :value="opcion.respuesta"
                @change="triggerOpcionMatch(pregunta, opcion.respuesta)"
                :key="opcion.respuesta"
                >
                <span style="cursor: pointer;">{{opcion.respuesta}}</span>
                </b-form-radio>
            </p>
        </b-col>
        <b-col cols="12" >
             <b-button
                style="float: right; margin: 0 10px 0 10px;"
                variant="primary"
                @click="verificarResultados"
            >Verificar Resultados</b-button>
        </b-col>
    </b-row>
</template>
<style lang="scss">
    .pre-quiz-activity{
        margin-top: 20px;
        margin-bottom: 20px;
        background-color: #ceebf0;
        border-radius: .5rem;
        padding-top: 10px;
        padding-bottom: 10px;
    }
//TODO: verificar los cuadros de carga como sus vistaS
</style>
<script>
    export default {
        name: 'pre-quiz',
        props: {
           data: {
               type: Object,
               default: () => {
                   return {
                       index: null,
                        tag: 'QuizContent',
                        preguntas: [],
                        instrucciones: ''
                   }
               }
           }
        },
        methods: {
             verificarResultados() {
                let aciertos = 0;

                this.data.preguntas.forEach((el, index) => {
                    let elementoTxt = document.getElementById(`txtPregunta${index}`);
                
                    el.opciones.forEach(op => {
                        if (op.isOk) {
                        if (el.match == op.respuesta) {
                            el.acierto = true;
                            elementoTxt.className = 'okAcierto';
                            aciertos++;
                        } else {
                            el.acierto = false;
                            elementoTxt.className = 'badAcierto';
                        }
                        }
                    });        
                });

                let promedio = (100 * aciertos) / this.data.preguntas.length;

                if (promedio >= 70) {
                    this.$swal({
                    type: "success",
                    title: "¡EN HORA BUENA!",
                    text: `Tu promedio de aciertos en esta actividad es del ${Math.round(promedio)}%`,
                    showCancelButton: false,
                    confirmButtonColor: "#285c4d",
                    confirmButtonText: "Aceptar"
                    }).then(result => {
                    if (result.value) {
                    }
                    });
                } else {
                    this.$swal({
                    type: "warning",
                    title: "¡PROMEDIO BAJO!",
                    text: `Tu promedio de aciertos es del ${Math.round(promedio)}%`,
                    showCancelButton: false,
                    confirmButtonColor: "#285c4d",
                    confirmButtonText: "Aceptar"
                    }).then(result => {
                    if (result.value) {
                    }
                    });
                }
            },
            triggerOpcionMatch(pregunta, value) {
                pregunta["match"] = value;
            }
        },
    }
</script>